import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarWiseDullAmountLedgerReport } from "../services/reports.services";
import { sumBy } from "lodash";

const DullKarigarLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarWiseDullAmountLedgerReportList = useAppSelector(
    (state) => state.reports.KarigarWiseDullAmountLedgerReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/dull-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const fetchKarigarWiseDullAmountLedgerReport = async (payload: any) => {
    await dispatch(getKarigarWiseDullAmountLedgerReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarWiseDullAmountLedgerReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Dull Karigar Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
            <Typography.h5
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              Karigar:{" "}
              {KarigarWiseDullAmountLedgerReportList?.[0]?.karigar_name}
            </Typography.h5>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarWiseDullAmountLedgerReportList &&
          KarigarWiseDullAmountLedgerReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th
                        className="col-date text-center"
                        style={{ width: "5%" }}
                      >
                        Order No
                      </th>
                      <th
                        className="col-date text-center"
                        style={{ width: "8%" }}
                      >
                        Order Date
                      </th>
                      <th className="col-desc" style={{ width: "15%" }}>
                        Product Name
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Issue weight
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Received Weight
                      </th>
                      <th
                        className="col-receipt-amount text-end"
                        style={{ width: "8%" }}
                      >
                        Charge
                      </th>
                      <th
                        className="col-receipt-amount text-end"
                        style={{ width: "8%" }}
                      >
                        Total Charge
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Ghat Weight
                      </th>
                      <th
                        className="col-phine-balance text-end"
                        style={{ width: "8%" }}
                      >
                        Gold Rate
                      </th>
                      <th
                        className="col-phine-balance text-end"
                        style={{ width: "8%" }}
                      >
                        Ghat Amount
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Total Amount
                      </th>
                      {/* <th
                        className="col-balance text-end"
                        style={{ width: "15%" }}
                      >
                        Balance
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarWiseDullAmountLedgerReportList.map(
                      (data, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td className="cell-date text-center">
                            {data?.order_no}
                          </td>
                          <td className="cell-date text-center">
                            {data?.Date}
                          </td>
                          <td
                            className="cell-desc"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index === 0 ? `Opening Balance` : data?.item_name}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.issue_weight &&
                              formatWeight(data?.issue_weight)) ||
                              ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.received_weight &&
                              formatWeight(data?.received_weight)) ||
                              ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.charges
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.charges,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.total_charge
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.total_charge,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.ghat_weight &&
                              formatWeight(data?.ghat_weight)) ||
                              ""}
                          </td>
                          <td className="cell-issue">
                            {data?.gold_rate
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.gold_rate,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue">
                            {data?.ghatt_amount
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.ghatt_amount,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.total_amount_calc
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data.total_amount_calc || 0,
                                )
                              : ""}
                          </td>
                          {/* <td
                            className="cell-balance"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {formatToIndianCurrencyWithoutSymbol(
                              data?.closing_amount || 0
                            )}{" "}
                            {data.creditdebittypeamount === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td> */}
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={3} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseDullAmountLedgerReportList,
                            "issue_weight",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseDullAmountLedgerReportList,
                            "received_weight",
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseDullAmountLedgerReportList,
                            "charges",
                          ),
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseDullAmountLedgerReportList,
                            "total_charge",
                          ),
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseDullAmountLedgerReportList,
                            "ghat_weight",
                          )
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default DullKarigarLedgerReportView;
